// extracted by mini-css-extract-plugin
export default {"about":"About_about__tm0go","container":"About_container__63eab","imgContainer":"About_imgContainer__KRUWz","family":"About_family__KoZOf"};